import { AxiosResponse } from 'axios';

import { api } from '../../http';
import {
  Asset,
  AssetForEdit,
  BaseFilter,
  PageRequest,
  PageResponse,
  TreeNodeBase
} from '../../types/interfaces';

import { ApiResponse } from './interfaces';

export interface ImportResponse {
  assets: Array<{
    assetState: boolean;
    externalId: string;
    name: string;
    assetClassId: number;
    assetClass: string;
    description: string;
    address: string;
  }>;
  errors: string[];
}

export const AssetsService = {
  getAssets(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
    }
  ): Promise<AxiosResponse<PageResponse<Asset> | undefined>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.append(key, String(params[key]));
      }
    });

    return api
      .get<ApiResponse<PageResponse<Asset>>>('asset', {
        params: searchParams
      })
      .then((resp) => {
        if (resp.data.isSuccess) {
          // "Разворачиваем" в старую форму
          return { ...resp, data: resp.data.value };
        } else {
          // При ошибке возвращаем data: undefined (либо можно выбросить ошибку)
          return { ...resp, data: undefined };
        }
      });
  },

  getAssetById(id: number): Promise<AxiosResponse<Asset | undefined>> {
    return api.get<ApiResponse<Asset>>(`asset/${id}`).then((resp) => {
      if (resp.data.isSuccess) {
        return { ...resp, data: resp.data.value };
      } else {
        return { ...resp, data: undefined };
      }
    });
  },

  updateAsset(
    id: number,
    asset: AssetForEdit
  ): Promise<AxiosResponse<ApiResponse<AssetForEdit>>> {
    return api.put<ApiResponse<AssetForEdit>>(`asset/${id}`, asset);
  },

  deleteAsset(id: number): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`asset/${id}`);
  },

  createAsset(
    asset: AssetForEdit
  ): Promise<AxiosResponse<ApiResponse<AssetForEdit>>> {
    return api.post<ApiResponse<AssetForEdit>>('asset', asset);
  },

  getAssetsTemplateExcel(): Promise<AxiosResponse<Blob>> {
    return api.get('asset/export/template', {
      responseType: 'blob'
    });
  },

  exportAssetsExcel(params: PageRequest): Promise<AxiosResponse<Blob>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.append(key, String(params[key]));
      }
    });
    return api.get('asset/export', {
      params: searchParams,
      responseType: 'blob'
    });
  },

  importAssets(
    formData: FormData,
    validation = false
  ): Promise<AxiosResponse<ImportResponse>> {
    return api.post<ImportResponse>('asset/import', formData, {
      // query-параметры:
      params: { validation },
      // заголовок для отправки файла:
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  getAssetsForSelection(): Promise<AxiosResponse<TreeNodeBase[]>> {
    return api.get<TreeNodeBase[]>('asset', {
      params: { ForSelection: 'true' }
    });
  }
};
